import ev from "../util/enumValue";

enum Orientation {
    PORTRAIT = ev('PORTRAIT', 1),
    LANDSCAPE = ev('LANDSCAPE', 2)
}

export default Orientation;
